import { roleEnum } from "shared/utils/Enum";

const RoleList = [
    {
        label: 'Admin',
        value: roleEnum.admin
    },
    {
        label: 'User',
        value: roleEnum.user
    }
];
export { RoleList };
